<ng-container *ngIf="codeData$ | async as codeData">
  <div class="card mb-4">
    <div class="card-body">
      <h5 class="fs-4 fw-bold card-title mb-4">Ingresa el código de seguridad</h5>
      <p *ngIf="codeData.data.type === 'EMAIL'; else sms">
        Ingresa el código de seguridad que enviamos a tu correo electrónico
        {{ codeData.data.destination }}
      </p>
      <ng-template #sms>
        <p>Ingresa el código de seguridad que enviamos a tu móvil {{ codeData.data.destination }}</p>
      </ng-template>
      <form [formGroup]="phoneValidationForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input type="string" class="form-control mb-2" formControlName="codePhone" maxlength="6" />
        </div>
      </form>
    </div>
  </div>
  <app-button (clicked)="onSubmit()" [loading]="loading"> Verificar </app-button>
</ng-container>
